import { UsersService } from '@/openapi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/util/queryKeys';

interface UpdateUserRoleMutationParams {
  userId: string;
  role: string;
}

export const useUpdateUserRoleMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (mutationVars: UpdateUserRoleMutationParams) =>
      UsersService.usersServiceSetUserRole({
        path: {
          id: mutationVars.userId,
        },
        body: {
          role: mutationVars.role,
        },
      }),
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.users.list(),
      });
    },
  });
};
